/* VTX blog promo (2026-09-29)
 * - moves the server-rendered inline card row after the first major (H2) section of the article
 * - moves the "Best picks" block right after the article body
 * - shows a compact sticky pill after ~35% of the article, hides it near the end block, dismissible
 * - add to cart via /cart/add.js, then renders the theme's cart-notification / cart-drawer (same as product-form.js)
 * - fires dataLayer + gtag events (view_item_list, select_item, view_promotion, select_promotion, vtx_blog_card_add_to_cart)
 */
(function () {
  if (window.__vtxBlogPromoV1) return;
  window.__vtxBlogPromoV1 = true;

  var content = document.querySelector('.article-template__content');
  var inline = document.querySelector('[data-vtx-bp-inline]');
  var best = document.querySelector('[data-vtx-bp-best]');
  var devices = document.querySelector('[data-vtx-bp-devices]'); // batch3: optional "Compare the devices" row
  var sticky = document.querySelector('[data-vtx-bp-sticky]');
  if (!content && !sticky) return;

  /* ---------------------------------------------------------------- analytics */
  function track(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: name };
      for (var k in params) payload[k] = params[k];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(payload);
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
    } catch (e2) {}
  }
  function itemFrom(card, list) {
    var d = card.dataset;
    return {
      item_id: d.vtxProductId,
      item_name: d.vtxItemName,
      item_variant: d.vtxVariantId,
      item_category: d.vtxTopic,
      item_list_id: list.id,
      item_list_name: list.name,
      index: parseInt(d.vtxIndex, 10) || 0,
      price: parseFloat(d.vtxPrice) || 0,
      currency: d.vtxCurrency,
      quantity: 1
    };
  }
  function listInfo(card) {
    var l = card.closest('[data-vtx-list-id]');
    return { el: l, id: l ? l.dataset.vtxListId : '', name: l ? l.dataset.vtxListName : '', placement: card.dataset.vtxBlogCard };
  }
  function baseParams(list) {
    return {
      vtx_article: (list.el && list.el.dataset.vtxArticle) || '',
      vtx_blog: (list.el && list.el.dataset.vtxBlog) || '',
      vtx_placement: list.placement,
      vtx_topic: (list.el && list.el.dataset.vtxTopic) || ''
    };
  }
  function observeList(el) {
    if (!el || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting || el.__vtxSeen) return;
        el.__vtxSeen = true; io.disconnect();
        var cards = el.querySelectorAll('.vtx-bp__card');
        var l = { el: el, id: el.dataset.vtxListId, name: el.dataset.vtxListName, placement: el.hasAttribute('data-vtx-bp-best') ? 'best' : (el.hasAttribute('data-vtx-bp-devices') ? 'devices' : 'inline') };
        var items = [];
        cards.forEach(function (c) { items.push(itemFrom(c, l)); });
        var p = baseParams(l); p.item_list_id = l.id; p.item_list_name = l.name; p.items = items;
        track('view_item_list', p);
      });
    }, { threshold: 0.4 });
    io.observe(el);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-vtx-blog-card-link]');
    if (a) {
      var card = a.closest('.vtx-bp__card');
      if (card) {
        var l = listInfo(card);
        var p = baseParams(l); p.item_list_id = l.id; p.item_list_name = l.name; p.items = [itemFrom(card, l)];
        track('select_item', p);
      } else {
        var lst = a.closest('[data-vtx-list-id]');
        if (lst) track('vtx_blog_card_view_all', { vtx_article: lst.dataset.vtxArticle, vtx_placement: a.getAttribute('data-vtx-blog-card-link'), vtx_topic: lst.dataset.vtxTopic });
      }
    }
    var s = e.target.closest && e.target.closest('[data-vtx-sticky-link]');
    if (s && sticky) {
      track('select_promotion', {
        promotion_id: sticky.dataset.vtxPromoId, promotion_name: 'Blog sticky - ' + sticky.dataset.vtxTopic,
        creative_name: (s.textContent || '').trim(), creative_slot: 'sticky_bottom_right',
        vtx_article: sticky.dataset.vtxArticle, vtx_blog: sticky.dataset.vtxBlog, vtx_topic: sticky.dataset.vtxTopic
      });
    }
  }, true);

  /* ------------------------------------------------------------- placement */
  function directChild(node) {
    while (node && node.parentNode !== content) node = node.parentNode;
    return node;
  }
  function placeInline() {
    if (!inline || !content) return;
    var kids = Array.prototype.slice.call(content.children);
    var total = content.getBoundingClientRect().height || 1;
    var top0 = content.getBoundingClientRect().top;
    var heads = [];
    content.querySelectorAll('h2').forEach(function (h) {
      var c = directChild(h);
      if (c && heads.indexOf(c) === -1 && kids.indexOf(c) > 0) heads.push(c);
    });
    var anchor = null; // insert BEFORE anchor
    // preferred: the end of the first major section = before the 2nd H2
    if (heads.length >= 2) {
      var pos = (heads[1].getBoundingClientRect().top - top0) / total;
      if (pos <= 0.5) anchor = heads[1];
    }
    // else first block boundary at/after ~35% of the article (never before the 2nd block)
    if (!anchor) {
      for (var i = 2; i < kids.length; i++) {
        var r = kids[i].getBoundingClientRect();
        if ((r.top - top0) / total >= 0.35 && !/^(LI|TR|TD|TBODY|THEAD)$/.test(kids[i].tagName)) { anchor = kids[i]; break; }
      }
    }
    if (anchor) content.insertBefore(inline, anchor); else content.appendChild(inline);
    inline.hidden = false;
    observeList(inline);
  }
  function placeBest() {
    if (!best || !content) return;
    content.parentNode.insertBefore(best, content.nextSibling);
    observeList(best);
  }
  function placeDevices() {
    if (!devices || !content) return;
    // right after the article body, i.e. before the "Best picks" block when both exist
    content.parentNode.insertBefore(devices, content.nextSibling);
    observeList(devices);
  }
  placeInline();
  placeBest();
  placeDevices();

  /* ---------------------------------------------------------- add to cart */
  function cartEl() { return document.querySelector('cart-notification') || document.querySelector('cart-drawer'); }
  function setBusy(btn, busy) {
    if (busy) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    else { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
  }
  function showError(card, msg) {
    var err = card.querySelector('.vtx-bp__err');
    if (!err) { err = document.createElement('p'); err.className = 'vtx-bp__err'; err.setAttribute('role', 'alert'); card.appendChild(err); }
    err.textContent = msg || (window.cartStrings && cartStrings.error) || '';
    err.hidden = false;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-vtx-atc]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var card = btn.closest('.vtx-bp__card');
    var err = card.querySelector('.vtx-bp__err'); if (err) err.hidden = true;
    var cart = cartEl();
    var body = new FormData();
    body.append('id', card.dataset.vtxVariantId);
    body.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      body.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
    }
    setBusy(btn, true);
    var base = ((window.routes && routes.cart_add_url) || '/cart/add').replace(/\.js$/, '') + '.js';
    fetch(base, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, credentials: 'same-origin', body: body })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (resp.status) { showError(card, resp.description || resp.message); return; }
        var l = listInfo(card);
        var p = baseParams(l); p.item_list_id = l.id; p.item_list_name = l.name; p.items = [itemFrom(card, l)];
        track('vtx_blog_card_add_to_cart', p);
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vtx-blog-card', productVariantId: card.dataset.vtxVariantId, cartData: resp });
        } catch (e1) {}
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(resp);
        } else {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: resp }));
        }
        var lab = btn.querySelector('[data-vtx-atc-label]');
        if (lab && btn.dataset.addedLabel) {
          var old = lab.textContent; lab.textContent = btn.dataset.addedLabel; btn.classList.add('is-added');
          setTimeout(function () { lab.textContent = old; btn.classList.remove('is-added'); }, 2200);
        }
      })
      .catch(function (er) { console.error('vtx blog card atc', er); showError(card); })
      .then(function () { setBusy(btn, false); });
  });

  /* --------------------------------------------------------------- sticky */
  if (sticky) {
    var KEY = 'vtx_bp_dismissed_' + (sticky.dataset.vtxTopic || 'generic');
    var dismissed = false;
    try { dismissed = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    if (dismissed) sticky.classList.add('is-dismissed');
    var link = sticky.querySelector('[data-vtx-sticky-link]');
    var closeBtn = sticky.querySelector('[data-vtx-sticky-close]');
    var shown = false, promoSent = false, ticking = false;

    function setVisible(v) {
      if (v === shown) return;
      shown = v;
      sticky.classList.toggle('is-visible', v);
      sticky.setAttribute('aria-hidden', v ? 'false' : 'true');
      if (link) link.tabIndex = v ? 0 : -1;
      if (closeBtn) closeBtn.tabIndex = v ? 0 : -1;
      if (v && !promoSent) {
        promoSent = true;
        track('view_promotion', {
          promotion_id: sticky.dataset.vtxPromoId, promotion_name: 'Blog sticky - ' + sticky.dataset.vtxTopic,
          creative_name: link ? link.textContent.trim() : '', creative_slot: 'sticky_bottom_right',
          vtx_article: sticky.dataset.vtxArticle, vtx_blog: sticky.dataset.vtxBlog, vtx_topic: sticky.dataset.vtxTopic
        });
      }
    }
    function evaluate() {
      ticking = false;
      if (dismissed || !content) { setVisible(false); return; }
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var r = content.getBoundingClientRect();
      var progress = (-r.top) / Math.max(r.height, 1); // share of the article body already scrolled past the top of the viewport
      var beforeEnd = true;
      var endEl = devices || best || null; // devices row (if any) sits first after the body
      if (endEl) {
        var b = endEl.getBoundingClientRect();
        if (b.top < vh - 40) beforeEnd = false; // end block in view: sticky not needed
      } else if (r.bottom < vh * 0.9) {
        beforeEnd = false;
      }
      setVisible(progress >= 0.35 && beforeEnd);
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(evaluate); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    if (closeBtn) closeBtn.addEventListener('click', function () {
      dismissed = true;
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      setVisible(false);
      track('vtx_blog_sticky_dismiss', { vtx_article: sticky.dataset.vtxArticle, vtx_topic: sticky.dataset.vtxTopic });
      setTimeout(function () { sticky.classList.add('is-dismissed'); }, 300);
    });
    evaluate();
  }
})();
